<template>
  <fragment>
    <b-row>
      <b-col>
        <Heading1 text="List of sessions">
          <b-button size="lg" variant="light" @click="fetchListReviewSession">
            <b-icon-arrow-repeat />
          </b-button>
          <CreateReviewSessionForm @onSubmit="createReviewSession" />
        </Heading1>

        <b-table striped hover :fields="reviewSessionFields" :items="listReviewSession" responsive="md">
          <!-- A virtual column -->
          <template v-slot:cell(status)="data">
            <StatusView
              :status="data.value"
              :isAdmin="isAdmin"
              @nextStatus="s => iSetReviewSessionStatus({ reviewSessionId: data.item.id, status: s })"
            />
          </template>

          <template v-slot:cell(updater)="data">
            <span class="small">{{ data.value.name }}</span>
          </template>

          <template v-slot:cell(updatedAt)="data">{{ fmtDate(data.value) }}</template>

          <template v-slot:cell(actions)="data">
            <ActionsView
              :status="data.item.status"
              :isAdmin="isAdmin"
              @deleteItem="() => deleteReviewSession(data.item.id)"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CreateReviewSessionForm from '@/components/CreateReviewSessionForm';
import StatusView from '@/components/StatusView';
import ActionsView from '@/components/ActionsView';
import Heading1 from '@/components/Heading1';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

export default {
  name: 'ManagingReviewSession',
  components: { CreateReviewSessionForm, StatusView, Heading1, ActionsView },
  data() {
    return {
      reviewSessionFields: [
        'period',
        'status',
        {
          key: 'updater',
          label: 'Author',
        },
        {
          key: 'updatedAt',
          label: 'Last update',
        },
        'actions',
      ],
    };
  },
  methods: {
    ...mapActions('review', [
      'fetchListReviewSession',
      'createReviewSession',
      'setReviewSessionStatus',
      'deleteReviewSession',
    ]),
    iSetReviewSessionStatus(input) {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: "Yes, I'm aware of it!",
        })
        .then(result => {
          if (result.value) {
            this.setReviewSessionStatus(input).then(() => {
              this.$swal.fire('Done!', 'Status was changed', 'success');
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters('review', ['listReviewSession']),
    ...mapGetters('app', ['isAdmin']),
  },
  mounted() {
    this.fetchListReviewSession();
  },
};
</script>
